import React from 'react';
import {t} from '@lingui/core/macro';

import Bell from 'shared/ui/icons/Bell';

import styles from './NotifyButton.module.scss';

interface NotifyButtonProps {
    loading: boolean;
    disabled: boolean;
    onClick: () => void;
}

const NotifyButton: React.FC<NotifyButtonProps> = ({disabled, loading, onClick}) => {
    return (
        <button
            className={styles.button}
            disabled={disabled || loading}
            onClick={onClick}
            type="button"
            aria-label={t`Отправить тестовое уведомление`}
            aria-disabled={disabled || loading}
            aria-busy={loading}
        >
            <Bell />
            {t`Отправить тестовое уведомление`}
        </button>
    );
};

export default NotifyButton;